import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/companyLogo.svg'


const _hoisted_1 = { class: "min-h-screen flex relative lg:static surface-ground" }
const _hoisted_2 = {
  id: "app-sidebar-2",
  class: "bg-bluegray-800 h-screen hidden lg:block flex-shrink-0 absolute lg:static left-0 top-0 z-1 select-none",
  style: {"width":"200px"}
}
const _hoisted_3 = { class: "flex flex-column h-full" }
const _hoisted_4 = { class: "overflow-y-auto mt-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  height: "100",
  style: {"opacity":"0.3"},
  alt: "LLPGROUP"
}, null, -1)
const _hoisted_6 = { class: "list-none p-3 m-0" }
const _hoisted_7 = { class: "flex align-items-center p-3 border-round text-bluegray-100" }
const _hoisted_8 = { class: "font-medium" }
const _hoisted_9 = { class: "flex align-items-center cursor-pointer p-3 hover:bg-bluegray-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-users mr-2" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Users", -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "flex align-items-center cursor-pointer p-3 hover:bg-bluegray-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-tags mr-2" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Companies", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "flex align-items-center cursor-pointer p-3 hover:bg-bluegray-900 border-round text-bluegray-100 hover:text-bluegray-50 transition-duration-150 transition-colors p-ripple" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-sign-out mr-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "logOut", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "min-h-screen flex flex-column relative flex-auto" }
const _hoisted_22 = { class: "p-5 flex flex-column flex-auto" }
const _hoisted_23 = { class: "border-2 border-dashed surface-border border-round surface-section flex-auto" }

import { ref } from "vue";
import router from "@/router";
import TableUsers from "@/components/TableUsers.vue";
import TableCompanies from "@/components/TableCompanies.vue";
import store from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'WindowAdmin',
  setup(__props) {

const table = ref("companies");

return (_ctx: any,_cache: any) => {
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(store).state.user.name), 1)
              ])
            ]),
            _createElementVNode("li", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (table.value = 'users'))
            }, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_9, _hoisted_12)), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (table.value = 'companies'))
            }, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_13, _hoisted_16)), [
                [_directive_ripple]
              ])
            ]),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(router).push('/')))
            }, [
              _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_17, _hoisted_20)), [
                [_directive_ripple]
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          (table.value === 'users')
            ? (_openBlock(), _createBlock(TableUsers, { key: 0 }))
            : _createCommentVNode("", true),
          (table.value === 'companies')
            ? (_openBlock(), _createBlock(TableCompanies, { key: 1 }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})